import React from 'react';
import { useSelector } from 'react-redux';
import { getUserName } from '@redux/selectors/UserSelector';

import Button from 'react-bootstrap/Button';
import matrixIcon from '@images/logos/vendor/matrix_logo.png';
import corelogicIcon from '@images/logos/vendor/corelogic-icon.svg';
import GAEventTracking from '@components/tracking/GAEventTracking';

const MatrixWidget = () => {
  const gaEventTracker = GAEventTracking('User');
  const username = useSelector(getUserName);

  return (
    <div className="panel-content text-center rounded" style={{ backgroundColor: '#ececec', minHeight: '231px' }}>
      <img alt="matrix-icon" src={matrixIcon} className="img-fluid mb-3" />
      <p className="mb-2">
        <span className="fa-stack fa-2x">
          <i className="fas fa-square fa-stack-2x" style={{ color: '#e92300' }} />
          <i className="fas fa-home fa-stack-1x fa-inverse" />
        </span>
      </p>
      <p className="mb-4" style={{ color: 'var(--darkBackground-4)' }}>
        MLS® System Powered By |
        <img alt="corelogic-icon" src={corelogicIcon} className="ml-2" style={{ height: '25px' }} />
      </p>
      <Button
        onClick={() => {
          window.open('https://matrix.pillarnine.com', '_blank');
          gaEventTracker('Opened Matrix', `${username}`);
        }}
        variant="primary"
      >
        <i className="far fa-external-link mr-2" />
        Matrix™
      </Button>
    </div>
  );
};

export default MatrixWidget;
